import React, { useState, useEffect } from "react";
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import "./printCounselCauseList.css";

const CauseListCounselWithSister = () => {
  const [isLoading, setLoading] = useState(false);
  const [dailyCauseList, setDailyCauseList] = useState([]);
  const [date, setDate] = useState("");

  //add suffix to date
  const dateSuffix = (day) => {
    if (day == 1 || day == 21 || day == 31) {
      return day + "" + "st";
    } else if (day == 2 || day == 22) {
      return day + "" + "nd";
    } else if (day == 3 || day == 23) {
      return day + "" + "rd";
    } else {
      return day + "" + "th";
    }
  };

  const formattedDate =
    date &&
    (
      new Date(date).toLocaleDateString("en-us", { weekday: "long" }) +
      ", " +
      dateSuffix(
        new Date(date).toLocaleDateString("en-us", { day: "numeric" }),
      ) +
      " day of " +
      new Date(date).toLocaleDateString("en-us", { month: "long" }) +
      ", " +
      new Date(date).toLocaleDateString("en-us", { year: "numeric" })
    ).toUpperCase();

  const curDate = new Date();
  const dateStr = (
    curDate.toLocaleDateString("en-us", { weekday: "long" }) +
    ", " +
    dateSuffix(curDate.toLocaleDateString("en-us", { day: "numeric" })) +
    " day of " +
    curDate.toLocaleDateString("en-us", { month: "long" }) +
    ", " +
    curDate.toLocaleDateString("en-us", { year: "numeric" })
  ).toUpperCase();

  const alphabetArray = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const alphabetForSisterCase = "abcdefghijklmnopqrstuvwxyz".split("");

  const todaysDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(currentDate.getDate()).padStart(2, "0");

    const formatDate = `${year}-${month}-${day}`;

    console.log("new", formatDate);
    return formatDate;
  };

  useEffect(() => {
    getDailyCauseList();
    dateSuffix();
  }, []);

  const getDailyCauseList = async () => {
    await endpoint
      .get(`/case-diary/new-day-list/${todaysDate()}`)
      .then(({ data }) => {
        let causeArr = data.data;

        const groupedData = causeArr.reduce((result, obj) => {
          const key =
            obj.CaseType.case_type + " " + obj.CaseTypeCategory.case_type_cat;

          if (!result[key]) {
            result[key] = [];
          }

          result[key].push(obj);

          return result;
        }, []);
        setDailyCauseList(groupedData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleFetchData = async () => {
    setLoading(true);
    await endpoint
      .get(`/case-diary/new-day-list/${date}`)
      .then(({ data }) => {
        let causeArr = data.data;
        const groupedByLocation = causeArr.reduce((result, obj) => {
          const location = obj.location || "N/A";

          if (!result[location]) {
            result[location] = {};
          }

          const key =
            obj.CaseType.case_type +
            " " +
            obj.CaseTypeCategory.case_type_cat +
            " " +
            (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : "");

          if (!result[location][key]) {
            result[location][key] = [];
          }

          result[location][key].push(obj);

          return result;
        }, []);
        console.log("groupedByLocation", groupedByLocation);
        setDailyCauseList(groupedByLocation);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  //function that adds "judgement" to heading
  const splitHeading = (str) => {
    const firstSpaceIndex = str.indexOf(" ");
    const firstPart = str.slice(0, firstSpaceIndex);
    return (firstPart + " " + "Judgment").toUpperCase();
  };

  //function that removes the adjournment id from heading
  const removeNumber = (str) => {
    const result = str.replace(/[0-9]/g, "");
    return (result + " " + "(s)").toUpperCase();
  };

  return (
    <>
      <div id="divToPrintCounselCauseList">
        <div className="row mt-4">
          <div
            className="col-md-12 text-center"
            id="hideDate"
            style={{ textDecoration: `underline` }}
          >
            <h3>COUNSEL LIST</h3>
            <br />
          </div>
          <div className="col">
            <label className="text-danger" id="hideDate">
              <i>
                **Please select date and click on search to print cause list**
              </i>
            </label>
            <div className="input-group mb-3" id="hideDate">
              <input
                type="date"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  onClick={handleFetchData}
                  id="button-addon2"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
          <div className="col"></div>
        </div>

        {isLoading && (
          <div className="d-flex align-items-center justify-content-center vh-100">
            <img
              src={"/loading.gif"}
              alt={""}
              className="img-fluid"
              style={{ maxWidth: "50px" }}
            />
          </div>
        )}

        {!isLoading && Object.entries(dailyCauseList).length > 0 && (
          <div className="row mt-4">
            <div className="col-md-12">
              {/* Print button at the top - outside location loop */}
              <div className="row mb-3">
                <div className="col-md-12 text-right">
                  <button
                    className="btn btn-outline-primary hideBtn"
                    type="button"
                    onClick={() => window.print()}
                  >
                    Print
                  </button>
                </div>
              </div>

              {Object.entries(dailyCauseList).map(
                ([location, groupings], locationIndex) => (
                  <div key={locationIndex} className="location-container">
                    {/* Court header - Wrap in a div without page-break properties */}
                    <div className="court-header-section counselMainHeading">
                      <div className="row">
                        <div
                          className="col-md-12 text-center"
                          style={{
                            textDecoration: `underline`,
                            fontWeight: "bold",
                          }}
                        >
                          <span>IN THE SUPREME COURT OF NIGERIA</span>
                          <br />
                          HOLDEN AT ABUJA <br />
                          {date ? formattedDate : dateStr.toUpperCase()} <br />
                          {location.toUpperCase()}
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-12 text-center">
                          Counsel are required to put their names opposite the
                          cases in this list in which they are engaged and to
                          supply the Registrar with lists of authorities they
                          intend to cite.
                        </div>
                      </div>
                      <div
                        className="text-center mb-4"
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          textDecoration: "underline",
                        }}
                      ></div>
                    </div>

                    {/* Tables - First one should appear right after header */}
                    {Object.entries(groupings)
                      .sort(([keyA], [keyB]) => {
                        const isMotionA = keyA.toLowerCase().includes("motion");
                        const isMotionB = keyB.toLowerCase().includes("motion");

                        if (isMotionA && !isMotionB) return -1;
                        if (!isMotionA && isMotionB) return 1;

                        return keyA.localeCompare(keyB);
                      })
                      .map(([headings, items], index) => (
                        <div key={index} className="counselListHeading">
                          <div className="table-responsive">
                            <table
                              className="table table-striped table-bordered mb-5"
                              style={{
                                tableLayout: `fixed`,
                                width: `100%`,
                                border: `1px solid black`,
                              }}
                            >
                              <thead className="thead-light">
                                <tr>
                                  <th
                                    rowSpan="2"
                                    style={{
                                      border: `1px solid black`,
                                      width: `70px`,
                                    }}
                                  >
                                    <strong>SNo.</strong>
                                  </th>
                                  <th
                                    rowSpan="2"
                                    className="heading-cell"
                                    style={{ border: `1px solid black` }}
                                  >
                                    <strong>
                                      {/* {alphabetArray[index]}.{headings.toUpperCase()} */}
                                      {headings.includes(2)
                                        ? `${alphabetArray[index]}. ${splitHeading(headings)}`
                                        : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                                    </strong>
                                  </th>
                                  <th
                                    colSpan="2"
                                    style={{
                                      border: `1px solid black`,
                                      textAlign: `center`,
                                    }}
                                  >
                                    <strong>COUNSEL'S NAME</strong>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    className="text-center"
                                    style={{ border: `1px solid black` }}
                                  >
                                    <strong>For Appellant</strong>
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ border: `1px solid black` }}
                                  >
                                    <strong>For Respondent</strong>
                                  </th>
                                </tr>
                              </thead>

                              <tbody style={{ border: `1px solid black` }}>
                                {items.length > 0 &&
                                  items.map((item, index) => (
                                    <>
                                      {item.CaseAttachements &&
                                        item.CaseAttachements.map(
                                          (Case, index2) => {
                                            const hasSisters =
                                              item.CaseAttachements.length > 1;
                                            return (
                                              <tr
                                                key={index}
                                                style={{
                                                  border: `1px solid black`,
                                                }}
                                              >
                                                {index2 === 0 && (
                                                  <td
                                                    rowSpan={
                                                      item.CaseAttachements
                                                        .length
                                                    }
                                                    style={{
                                                      border: `1px solid black`,
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {index + 1}.
                                                  </td>
                                                )}
                                                <td
                                                  style={{
                                                    whiteSpace: `normal`,
                                                    paddingBottom: `100px`,
                                                    border: `1px solid black`,
                                                  }}
                                                >
                                                  <span className="mb-2">
                                                    <strong>
                                                      {hasSisters
                                                        ? `${alphabetForSisterCase[index2]}. ${Case.suite_no}`
                                                        : Case.suite_no}
                                                    </strong>
                                                  </span>
                                                  <p
                                                    style={{
                                                      paddingTop: `5px`,
                                                      fontSize: `16px`,
                                                    }}
                                                  >
                                                    {Case.appellants}
                                                    {Case.otherAppellantCount ===
                                                    1 ? (
                                                      <>
                                                        <strong>
                                                          {" "}
                                                          & Anor{" "}
                                                        </strong>
                                                      </>
                                                    ) : Case.otherAppellantCount >
                                                      1 ? (
                                                      <>
                                                        {" "}
                                                        &{" "}
                                                        <strong>
                                                          {
                                                            Case.otherAppellantCount
                                                          }{" "}
                                                          Ors
                                                        </strong>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}{" "}
                                                    ({Case.appellants_title})
                                                  </p>
                                                  <p
                                                    style={{ fontSize: `16px` }}
                                                  >
                                                    VS.
                                                  </p>
                                                  <p
                                                    style={{
                                                      paddingTop: `5px`,
                                                      fontSize: `16px`,
                                                    }}
                                                  >
                                                    {Case.respondent}
                                                    {Case.otherRespondentCount ===
                                                    1 ? (
                                                      <>
                                                        <strong>
                                                          {" "}
                                                          & Anor{" "}
                                                        </strong>
                                                      </>
                                                    ) : Case.otherRespondentCount >
                                                      1 ? (
                                                      <>
                                                        {" "}
                                                        &{" "}
                                                        <strong>
                                                          {
                                                            Case.otherRespondentCount
                                                          }{" "}
                                                          Ors
                                                        </strong>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}{" "}
                                                    ({Case.respondent_title})
                                                  </p>
                                                </td>

                                                <td
                                                  style={{
                                                    border: `1px solid black`,
                                                  }}
                                                ></td>
                                                <td
                                                  style={{
                                                    border: `1px solid black`,
                                                  }}
                                                ></td>
                                              </tr>
                                            );
                                          },
                                        )}
                                    </>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ))}
                  </div>
                ),
              )}
            </div>
          </div>
        )}

        {/* Print button at the bottom */}
        {Object.entries(dailyCauseList).length > 0 && (
          <div className="row mt-4">
            <div className="col-md-12 text-right">
              <button
                className="btn btn-outline-primary hideBtn"
                type="button"
                onClick={() => window.print()}
              >
                Print
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CauseListCounselWithSister;
